import { clampClipRatio } from './clampClipRatio';

/** The legacy Satisfying split geometry as a fractional rect — used to seed
 *  clipRect on the first drag so the cell doesn't jump. Mirrors
 *  SatisfatorioFrame: portrait stacks top/bottom, landscape side-by-side;
 *  clipPosition 'bottom' puts the clip second on the split axis. */
export function computeSplitCellRect(
  config: { clipPosition?: string; clipRatio?: number },
  isLandscape: boolean,
): { x: number; y: number; w: number; h: number } {
  const ratio = clampClipRatio(config.clipRatio as number) / 100;
  const clipFirst = config.clipPosition !== 'bottom';
  if (isLandscape) {
    return { x: clipFirst ? 0 : 1 - ratio, y: 0, w: ratio, h: 1 };
  }
  return { x: 0, y: clipFirst ? 0 : 1 - ratio, w: 1, h: ratio };
}

/** Inverse of computeSplitCellRect's sizing: the clip's share of the split
 *  axis (height for portrait, width for landscape) as a clamped 10–90 integer
 *  "Tamanho do Clipe". Used to keep the ratio slider synced when the cell is
 *  resized visually, so the filler region's size stays consistent. */
export function clipRectToRatio(
  rect: { w: number; h: number; x?: number; y?: number },
  isLandscape: boolean,
): number {
  const dim = isLandscape ? rect.w : rect.h;
  return Math.round(clampClipRatio(dim * 100));
}
